export default {
  message: {
    "Loading": "載入中...",
    "PaymentConfirming": "檢查交易狀態...",
    "Check": "檢查",
    "CheckFail": "交易未完成。請在 5 秒後再次檢查。",
    "secondsago": "{time} 秒前",
    "Addname": "將 '{name}' 添加到您的名稱中",
    "Restattcheck": "重啟應用以檢查",
    "Copyname": "複製 '{name}'",
    "SubmissionFailed": "提交失敗，請稍後再試",
    "WithdrawalReview": "提現審核",
    "WebWithdrawAwaitTip": "* 估計需要 24-48 小時。邀請更多朋友可以加快審核過程。",
    "Success": "成功",
    "Rejection": "拒絕",
    "WebSubmittedTip": "已提交，預計在 24-48 小時內處理",
    "shop": "商店",
    "topurchase": "前往商店購買",
    "shopDesc": "限量供應——快來搶購吧！",
    "claim": "收取",
    "payment_success": "付款成功",
    "payment_failed": "付款失敗",
    "payment_cancelled": "付款已取消",
    "opening_payment": "開啟付款...",
    "payment_status": "付款狀態",
    "create_order_failed": "建立訂單失敗",
    "creating_ton_order": "正在建立TON訂單...",
    "next_step": "下一步驟",
    "use_ton_payment": "使用TON付款",
    "start_transaction": "開始交易",
    "connect_wallet": "連接錢包",
    "address": "地址",
    "amount_ton": "數量 TON",
    "copy": "複製",
    "amount": "數量",
    "wallet_address": "錢包地址",
    "comment_memo": "備註備忘錄",
    "you_can_choose_to_connect_wallet_to_pay": "您可以選擇連接錢包付款",
    "or_manually_transfer_to_the_above_address": "或手動轉帳到上述地址（請注意金額和備忘錄必須完全相同）",
    "transaction_success": "交易成功",
    "transaction_failed": "交易失敗",
    "transaction_error": "交易錯誤",
    "transaction_status": "交易狀態",
    "transaction_id": "交易ID",
    "transaction_amount": "交易金額",
    "transaction_status_desc": "交易狀態描述",
    "payment_status_tip": "請等待付款確認",
    "select_payment_method": "選擇付款方式",
    "total_amount": "總金額",
    "creating_order": "創建訂單中...",
    "order_created": "訂單已創建",
    "order_status": "訂單狀態",
    "Applyforwithdrawal": "申請提款",
    "Withdrawalunlock": "提款解鎖中",
    "WithdrawalunlockTip": "您需要{num}位邀請朋友完成任務/綁定錢包以解鎖提款",
    "Close": "關閉",
    "Delivering": "配送中",
    "Duetothelargenumber": "由於收件人數量眾多，您的空投預計在15-20個工作日內送達",
    "error": "發生錯誤！",
    "Sorrysomeerrorsoccurred": "抱歉，發生了一些錯誤",
    "quit": "退出",
    "language": "語言",
    "Youcanchangethelanguagehere": "您可以在這裡更改語言！",
    "current": "當前",
    "home": "主頁",
    "friends": "朋友",
    "wallet": "錢包",
    "aboutus": "關於我們",
    "Sharewithfriends": "與朋友分享",
    "copyFailure": "複製失敗",
    "copySuccess": "複製成功",
    "Claimreward": "獲取獎勵",
    "DailyLogin": "每日登入",
    "noInvitationsYet": "尚未收到邀請",
    "LoadMore": "加載更多",
    "WatchAD": "觀看廣告",
    "continue": "繼續",
    "Congratulations": "恭喜",
    "MyFriends": "我的朋友",
    "Invitefriends": "邀請朋友",
    "Invitepremiumfriends": "邀請高級朋友",
    "DailyTasks": "每日任務",
    "inviteDesc": "每邀請一位朋友可獲得 +{num} ${name}",
    "DailyTasksDesc": "完成任務以獲得更多 ${name}",
    "SponsorsandPartners": "贊助商和合作夥伴",
    "Receivingwallet": "接收錢包",
    "Enterwalletaddress": "輸入 {name} 錢包地址",
    "Claim": "獲取",
    "Booster": "增強器",
    "RentPeriod": "租用期間",
    "days30": "30 天",
    "days": "天",
    "Dailyprofit": "每日利潤",
    "Totalprofit": "總利潤",
    "Quantity": "數量",
    "RentPrice": "租金價格",
    "RentMiner": "租用礦工",
    "Insufficient": "資金不足 ${name}",
    "InsufficientMsg": "需要 {num} ${name1}，邀請朋友或完成任務以賺取更多 ${name2}。",
    "Settings": "設置",
    "copyid": "複製 ID",
    "UpgradeSuccessfully": "升級成功",
    "Name": "姓名",
    "userinfo": "用戶信息",
    "disconnect": "斷開連接",
    "Startmining": "開始挖礦",
    "Welcome": "歡迎來到 {name}",
    "Withdrawal": "提現",
    "Minimumamount": "最低金額",
    "Networkfee": "網絡費用",
    "Enteramount": "輸入金額",
    "Submit": "提交",
    "MinimumTip": "提現金額太小。最低提現金額：{num}",
    "MaximumTip": "金額不足，您可以提現的最大金額為：{num}",
    "SubmittedTip": "已提交，預計在 30-60 個工作日內處理",
    "WithdrawStatus": "狀態",
    "Submissiontime": "提交時間",
    "WithdrawAwaitTip": "* 估計需要 30-60 個工作日。邀請更多朋友可以加快審核過程。",
    "Processing": "處理中",
    "Amount": "金額",
    "Numberoffriends": "朋友數量：{now}/{limit}",
    "InviteTip": "要進行首次提現，您需要邀請 {limit} 位朋友加入挖礦應用程序。",
    "openonphone": "在手機上打開此鏈接。",
    "claimTip": "要收取的金額太小。最低可收取金額為：{num}",
    "WalletBalance": "錢包餘額",
    "Withdraw": "提現",
    "SetWalletAddress": "設置錢包地址",
    "WithdrawalRecord": "提現記錄",
    "Norecords": "無記錄",
    "Whatis": "什麼是 {name}?",
    "All": "全部",
    "save": "保存",
    "successWithdrawal": "提現已收到 {num}",
    "select_network": "選擇網路",
    "confirm": "確認",
    "switching_network": "切換網路中...",
    "network_switched": "網路切換完成",
    "use_usdt_payment": "使用USDT付款",
    "or_manually_transfer_to_the_above_address_usdt": "手動轉帳到上述地址（請注意金額和地址必須完全相同）",
    "chain_type": "網絡",
    "check_transaction_status": "檢查交易狀態",
    "transaction_wait": "交易正在處理中。您可以退出應用程式。完成後會有消息通知您。",
    "twa_pay_tip_with_memo": "請確保地址、金額和備註一致以進行轉帳。",
    "twa_pay_tip": "請確保地址和金額正確以進行轉帳。",
    "creating_usdt_order": "正在創建 USDT 訂單...",
    "affiliate_programs": "聯盟計劃",
    "affiliate_programs_description": "邀請朋友加入挖礦應用程式並獲得獎勵。",
    "commission_details": "佣金詳情",
    "no_commission_records": "沒有佣金記錄",
    "commission_list": "佣金列表",
    "input_amount": "輸入金額",
    "max": "最大",
    "commission_input_amount": "輸入佣金金額",
    "min_commission": "最低提款金額為 {num}",
    "WithdrawalSuccess": "提款成功",
    "WithdrawalFailed": "提款失敗",
    "WithdrawalProcessing": "提款處理中",
    "award": "獎勵",
    "level": "等級",
    "Share_to_group": "分享到群組",
    "Exchange": "交換",
    "balance_not_enough": "餘額不足，您只能交換 {num} {coin}",
    "exchange_fail": "交換失敗",
    "exchange_success": "交換成功",
    "you_will_receive": "您將收到",
    "ShareToGroups": "分享至群組",
    "Numberofgroups": "群組數量： {now}/{limit}",
    "Confirm": "確認",
    "ShareToGroupsDesc": "分享至群組以獲得更多 {name}",
    "TokenAddress": "請輸入提現細節，例如交易所ID或USDT地址",
    "CashAddress": "請輸入提現細節，例如銀行卡號或USDT地址",
    "Cancel": "取消",
    "min_withdrawal_amount": "最低提款金額為 {num} {coin}",
    "max_withdrawal_amount": "最高提款金額為 {num} {coin}",
    "withdrawal_failed": "提款失敗",
    "withdrawal_success": "提款成功",
    "PayNow": "立即付款",
    "PaySkip": "支付 {num} 以立即解鎖提款",
    "NumberofGroups": "群組數量: {now}/{limit}",
    "SendMessage": "發送訊息",
    "NumberofShares": "分享數量: {now}/{limit}",
    "NumberofTasks": "任務數量: {now}/{limit}",
    "CompleteTask": "完成任務",
    "PleaseEnterValidAmount": "請輸入有效的金額",
    "PleaseEnterValidEmail": "請輸入有效的電子郵件",
    "Feedback": "反饋",
    "Inputfeedbackcontent": "輸入反饋內容",
    "Submitfeedback": "提交反饋",
    "Pleaseenteravalidemailaddress": "請輸入有效的電子郵件地址",
    "Pleaseenteryouremailaddress": "請輸入您的電子郵件地址",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "您今天已經提供過反饋，請明天再來",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "反饋提交成功，感謝您寶貴的反饋",
    "Feedback_submission_failed_please_retry": "反饋提交失敗，請重試",
    "ContactUs": "聯繫我們",
    "XRPAddress": "請填寫已激活的 XRP 鏈錢包地址（包含 MEMO），否則您將無法提現。",
    "Accelerated": "加速",
    "Accelerated_withdrawals_success": "成功加速提現",
    "login": "登入",
    "register": "註冊",
    "login_with_google": "使用 Google 登入",
    "or": "或",
    "email": "電子郵件",
    "password": "密碼",
    "no_account": "還沒有帳戶",
    "click_to_go": "點擊以",
    "have_account": "已有帳戶",
    "go_to": "前往",
    "invite_code": "邀請碼",
    "optional": "選填",
    "google_login_not_ready": "Google 登入尚未準備好，請稍後再試",
    "password_too_long": "密碼過長",
    "weak": "弱",
    "medium": "中",
    "strong": "強",
    "login_success": "登入成功",
    "login_failed": "登入失敗",
    "please_input_email": "請輸入您的電子郵件",
    "invalid_email": "電子郵件格式無效",
    "please_input_password": "請輸入您的密碼",
    "password_length_6_to_16": "密碼必須為 6-16 字元",
    "account_or_password_error": "帳戶或密碼錯誤",
    "register_success": "註冊成功",
    "register_failed": "註冊失敗",
    "save_error": "保存錯誤，請稍後再試",
    "ShareToFriends": "分享給朋友",
    "login_first": "請先登入",
    "WalletBscError": "❌ 無效的 BNB 鏈錢包地址。",
    "DownloadWallet": "下載錢包",
    "AddToHomeScreen": "將 {appName} 添加到主屏幕",
    "TapShareInToolbar": "在工具列中輕觸",
    "SelectAddToHomeScreen": "選擇添加到主屏幕",
    "OpenToolbar": "打開工具列",
    "ClaimFailed": "領取失敗，請稍後再試",
    "guest_login": "訪客登入",
    "please_input_phone": "請輸入您的電話號碼",
    "email_error_1": "請輸入您的電子郵件",
    "email_error_2": "請輸入有效的電子郵件地址",
    "email_error_3": "不允許使用訪客電子郵件，請使用真實電子郵件",
    "phone": "電話",
    "phone_error_1": "請輸入您的電話號碼",
    "phone_error_2": "請輸入有效的電話號碼",
    "update_info": "更新資訊",
    "update_success": "更新成功",
    "update_failed": "更新失敗，請稍後再試",
    "cancel": "取消",
    "guest_credentials_title": "帳戶資訊",
    "guest_credentials_warning": "請截圖以保存您的帳戶和密碼。如果遺失，您的收益將無法恢復！",
    "i_have_saved": "我已保存",
    "account": "帳戶",
    "view_credentials": "查看憑證",
    "miner_max_reached": "您已達到此礦工的最大數量"
}};